import { M_Container, modulesVariants } from "./Modules.styled";
import { observer } from "mobx-react";
import { useStores } from "../../../../../../stores";
import { ModuleItem } from "./ModuleItem/ModuleItem";
import { useParams } from "react-router-dom";

interface ModulesProps {}

export const Modules = observer(({}: ModulesProps) => {
	const { grandCharts } = useStores();
	const { selected } = grandCharts;

	const { moduleId } = useParams<{
		moduleId: string;
	}>();

	const activeModuleId = Number(moduleId);

	return (
		<M_Container variants={modulesVariants}>
			{selected.grand_chart_modules.map((grandChartModule) => (
				<ModuleItem
					key={grandChartModule.id}
					isActive={activeModuleId === grandChartModule.id}
					service={selected.service.slug}
					grandChartModule={grandChartModule}
				/>
			))}
		</M_Container>
	);
});
